<!--
 * @Author: 郑攀
 * @Date: 2025-01-06 16:40:03
 * @LastEditors: 郑攀
 * @LastEditTime: 2025-01-09 15:41:13
 * @Description: 我的模板
 -->
<template>
  <div class="myTemplate-container">
    <MyTemplate />
    <!-- <a-tabs default-active-key="1" :animated="true" :destroyInactiveTabPane="true">
      <a-tab-pane key="1" tab="我的模板">
        <MyTemplate />
      </a-tab-pane>
      <a-tab-pane key="2" tab="我的下载">
        <MyDownload />
      </a-tab-pane>
      <a-tab-pane key="3" tab="我的收藏">
        <MyCollection />
      </a-tab-pane>
    </a-tabs> -->
  </div>
</template>

<script>
import MyTemplate from './myTemplate.vue'
import MyDownload from './myDownload.vue'
import MyCollection from './myCollection.vue'
import { selectAllIndustries } from '@/api/projectModelApi'

export default {
  name: 'MyTemplateIndex',
  components: {
    MyTemplate,
    MyDownload,
    MyCollection
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.myTemplate-container {
  width: 100%;
  height: 100%;
  display: grid;
}
</style>
